// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoDisplaySelector_root__3ITV1"};